import Form from 'mlmi-library/components/form/v1/form'
import 'mlmi-library/plugins/scroll-to'
import { TRANSITION_END } from 'mlmi-library/utils/animation'

const localeSettings = {
  style: 'currency',
  currency: 'CAD',
  currencyDisplay: 'symbol',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
}

$.fn.EventsSelector = function(steps) {
  let self = this
  self.hidden_field = self.find('input[name="inscription_price"]')
  self.display_field = self.find('.display-price-cell')

  self.update_price = function(price) {
    self.hidden_field.val(price)
    if (price > 0) {
      self.display_field.text(price.toLocaleString('fr-CA', localeSettings).replace('CA', '').trim())
    }
  }

  self.update_fields = function() {
    let price = -1, selected_events = []
    if (self.find('input[name="events-registration"][value="all"]').prop('checked')) {
      price = self.find('input[name="events-registration"][value="all"]').data('price')
      self.find('input[name="events-selection"]').each(function() {
        selected_events.push($(this).val())
      })
    } else {
      let one_is_left_unchecked = false
      self.find('input[name="events-selection"]').each(function() {
        if ($(this).prop('checked')) {
          if (price == -1) {
            price = 0
          }
          price += $(this).data('price')
          selected_events.push($(this).val())
        } else {
          one_is_left_unchecked = true
        }
      })
      if (!one_is_left_unchecked) {
        price = self.find('input[name="events-registration"][value="all"]').data('price')
      }
    }
    if (price == -1) {
      self.hidden_field.val('')
      if ($('.field--single-choice').length) {
        self.display_field.text('Veuillez sélectionner un événement ci-dessus.')
      } else {
        self.display_field.text('Veuillez sélectionner au moins un événement ci-dessus.')
      }
    } else if (price == 0) {
      self.hidden_field.val('0')
      self.display_field.text('Activité gratuite.')
      self.update_price(0)
    } else {
      self.update_price(price)
    }
    if (selected_events.length) {
      $('input[name="events"]').val(JSON.stringify(selected_events))
    } else {
      $('input[name="events"]').val('')
    }
  }

  self.initialize_series = function() {
    let field = self.find('input[name="events-registration"]:checked')
    if (field.val() == 'all') {
      steps.selected_mode = 'all'
      $('input[name="events-selection"]').prop('disabled', true).prop('checked', false)
    } else if (field.val() == 'some') {
      steps.selected_mode = 'some'
      $('input[name="events-selection"]').each(function() {
        if (!$(this).closest('.field').hasClass('field--full')) {
          $(this).prop('disabled', false)
        }
      })
    } else { // probably just single choice
      $('.field--full input[name="events-selection"]').prop('disabled', true).prop('checked', false)
    }
    self.update_fields()
  }

  self.initialize_fields = function() {
    self.find('input[name="events-registration"]').on('change', self.initialize_series)
    self.find('input[name="events-selection"]').on('change', function() {
      if ($(this).val() == 'all') {
        $('input[name="events-selection"]').prop('disabled', true).prop('checked', false)
        steps.selected_mode = 'all'
      } else if ($(this).val() == 'some') {
        steps.selected_mode = 'some'
        $('input[name="events-selection"]').prop('disabled', false)
      }
      self.update_fields()
    })
  }

  return function() {
    self.initialize_fields()
    self.initialize_series()
    return self
  }()
}

$.fn.FormInscription_Part1 = function(steps) {
  let self = this
  self.form = undefined

  self.handle_success = function(response) {
    steps.setFormID(response.form_id)
    steps.nextStep()
  }

  self.initialize_form = function() {
    self.form = new Form('.inscription-form__part-1', {
      ajax_redirect: false,
      ajax_url: culturemontreal_l10n.ajax_url,
      auto_scroll: true,
      onSuccess: self.handle_success,
    })
  }

  self.initialize_fields = function() {
    $('.events-selector').EventsSelector(steps)
  }

  self.update_fields = function() {
    //
  }

  return function() {
    self.initialize_form()
    self.initialize_fields()
    return self
  }()
}

$.fn.FormInscription_Part2 = function(steps) {
  let self = this
  self.form = undefined

  self.handle_success = function() {
    steps.nextStep()
  }

  self.initialize_form = function() {
    self.form = new Form('.inscription-form__part-2', {
      ajax_redirect: false,
      ajax_url: culturemontreal_l10n.ajax_url,
      auto_scroll: true,
      onSuccess: self.handle_success,
    })
  }

  self.initialize_fields = function() {
    // if (location.hostname == 'localhost') {
    //   self.find('input[name="prenom"]').val('Mathieu')
    //   self.find('input[name="nom"]').val('Lajeunesse')
    //   self.find('input[name="phone"]').val('514-625-4815')
    //   self.find('input[name="email"]').val('mlajeunesse@gmail.com')
    //   self.find('input[name="adresse"]').val('927, rue Montaigne')
    //   self.find('input[name="ville"]').val('Deux-Montagnes')
    //   self.find('input[name="prenom"]').val('Mathieu')
    //   self.find('input[name="code_postal"]').val('J7R 6S2')
    // }
    self.find('select[name="province"]').on('change', function() {
      if ($(this).val() == 'Hors Canada') {
        self.find('input[name="pays"]').val('')
        $('.field-container--pays').addClass('visible')
      } else {
        self.find('input[name="pays"]').val('Canada')
        $('.field-container--pays').removeClass('visible')
      }
    })
  }

  self.update_fields = function() {
    //
  }

  return function() {
    self.initialize_form()
    self.initialize_fields()
    return self
  }()
}

$.fn.FormInscription_Part3 = function(steps) {
  let self = this
  self.form = undefined

  self.handle_success = function(response) {
    steps.nextStep()
    if ('payment' in response) {
      steps.initializeStripe(response.payment)
    }
  }

  self.initialize_form = function() {
    self.form = new Form('.inscription-form__part-3', {
      ajax_redirect: false,
      ajax_url: culturemontreal_l10n.ajax_url,
      auto_scroll: true,
      onSuccess: self.handle_success,
    })
  }

  self.initialize_fields = function() {
    self.find('select[name="activite_secteur"]').on('change', function() {
      if ($(this).val() == 44) {
        $('.field-container--discipline').addClass('visible')
      } else {
        $('.field-container--discipline').removeClass('visible')
      }
    })
  }

  self.update_fields = function() {
    //
  }

  return function() {
    self.initialize_form()
    self.initialize_fields()
    return self
  }()
}


$.fn.FormInscription_Part4 = function(steps) {
  let self = this
  self.form = undefined
  self.stripe_fore = undefined

  self.handle_success = function(x) {
    location.href = x.redirect
  }

  self.initialize_form = function() {
    self.form = new Form('.inscription-form__part-4', {
      ajax_redirect: false,
      ajax_url: culturemontreal_l10n.ajax_url,
      auto_scroll: true,
      onSuccess: self.handle_success,
    })

    /* Back link */
    $('.inscription-details__back-link').on('click', function() {
      $('#inscription-form-tab-1').click()
    })
  }

  self.initialize_fields = function() {
    self.find('select[name="activite_secteur"]').on('change', function() {
      if ($(this).val() == 44) {
        $('.field-container--discipline').addClass('visible')
      } else {
        $('.field-container--discipline').removeClass('visible')
      }
    })

    /* Initial total */
    let total = parseFloat($('input[name="inscription_price"]').val())

    /* Méthode de paiement */
    self.find('input[name="methode_paiement"]').on('change', function() {
      if ($(this).val() == 'cheque') {
        $('.inscription-form__part-4 .submit-container').css('display', '')
        $('#stripe-payment-form').hide()
      } else if ($(this).val() == 'credit') {
        $('.inscription-form__part-4 .submit-container').css('display', 'none')
        $('#stripe-payment-form').show()
      }
    }).trigger('change')
  }

  self.update_fields = function() {
    /* Step 2 values */
    if (steps.forms.step_2 != undefined) {
      let form_step2 = steps.forms.step_2.form.form
      $('.inscription-details__cell--full-name').text(form_step2.get_form_value('prenom') + ' ' + form_step2.get_form_value('nom'))
      $('.inscription-details__cell--address-1').text(form_step2.get_form_value('adresse'))
      $('.inscription-details__item--address-2').hide()
      $('.inscription-details__cell--city').text(form_step2.get_form_value('ville'))
      let province = form_step2.get_form_value('province'),
      country = form_step2.get_form_value('pays')
      if (province == 'Hors Canada') {
        $('.inscription-details__cell--province').text('')
        $('.inscription-details__item--province').hide()
        $('.inscription-details__cell--country').text(form_step2.get_form_value('country').toUpperCase())
        $('.inscription-details__item--country').show()
      } else {
        $('.inscription-details__cell--province').text(form_step2.get_form_value('province'))
        $('.inscription-details__item--province').show()
        $('.inscription-details__cell--country').text('')
        $('.inscription-details__item--country').hide()
      }
      $('.inscription-details__cell--postal-code').text(form_step2.get_form_value('code_postal'))
      $('.inscription-details__cell--phone').text(form_step2.get_form_value('phone'))
      $('.inscription-details__cell--email').text(form_step2.get_form_value('email'))
    }

    /* Updated total */
    let total = parseFloat($('input[name="inscription_price"]').val())
    $('.paypal-form input[name="amount"]').val(total)
    $('.stripe-form input[name="stripeTotal"]').val(Math.round(total * 100))

    /* Updated event if radio */
    if ($('.field--single-choice').length) {
      let event_string = $('.events-selector__events-selection input:checked ~ .field__label').data('label')
      if (!event_string) {
        event_string = $('.events-selector__events-selection input:checked ~ .field__label').html()
      }
      $('.inscription-details__items--selection .inscription-details__item').html(event_string)
    } else if (steps.selected_mode == 'some' && $('.events-selector__events-selection input:checked').length) {
      let events_string = []
      $('.events-selector__events-selection input:checked').each(function() {
        let event_string = $(this).parent().find('input:checked ~ .field__label').data('label')
        if (!event_string) {
          event_string = $(this).parent().find('input:checked ~ .field__label').html()
        }
        events_string.push(event_string)
      })
      $('.inscription-details__items--selection .inscription-details__item').html(events_string.join('<br>'))
    } else {
      let event_string = $('input[name="events-registration"][value="all"] ~ .field__label').data('label')
      if (!event_string) {
        event_string = $('input[name="events-registration"][value="all"] ~ .field__label').html()
      }
      $('.inscription-details__items--selection .inscription-details__item').html(event_string)
    }

    /* No payment */
    if (total == 0 || !total) {
      $('.field-container--methode_paiement').hide()
      $('input[name="methode_paiement"][value="cheque"]').prop('checked', true).change()
      self.find('.field__submit').text("M'inscrire").show()
    } else {
      $('.field-container--methode_paiement').show()
      $('input[name="methode_paiement"][value="credit"]').prop('checked', true).change()
      // temp
      $('.field-container--methode_paiement .field-options .field--type-radio:last-child').hide()
    }
  }

  return function() {
    self.initialize_form()
    self.initialize_fields()
    return self
  }()
}

export default {
  current: 1,
  forms: {
    step_1: undefined,
    step_2: undefined,
    step_3: undefined,
    step_4: undefined,
  },
  selected_mode: 'all',

  init() {
    let steps = this

    $('.form-steps__item').on('click', function() {
      steps.switchTo($(this).data('index'))
    })

    $('.inscription-form__part-1').each(function() {
      steps.forms.step_1 = $(this).FormInscription_Part1(steps)
    })

    $('.inscription-form__part-2').each(function() {
      steps.forms.step_2 = $(this).FormInscription_Part2(steps)
    })

    $('.inscription-form__part-3').each(function() {
      steps.forms.step_3 = $(this).FormInscription_Part3(steps)
    })

    $('.inscription-form__part-4').each(function() {
      steps.forms.step_4 = $(this).FormInscription_Part4(steps)
    })

    $('.inscription-form__step--2, .inscription-form__step--3, .inscription-form__step--4').hide()
  },

  switchTo(step) {
    let steps = this
    $('.form-steps').attr('data-current-step', step)
    $('.form-steps__item').attr('aria-selected', 'false')
    $('.form-steps__item[data-index="' + step + '"]').attr('aria-selected', 'true')
    $('html, body').scrollTo(0, 350, 4, 'easeInOutQuart')
    $('.inscription-form__step--' + steps.current).attr('aria-hidden', 'true').one(TRANSITION_END, function() {
      $('.inscription-form__step--' + steps.current).off(TRANSITION_END)
      $('.inscription-form__step--' + steps.current).hide()
      steps.forms['step_' + step].form.form.enable_fields()
      steps.forms['step_' + step].update_fields()
      $('.inscription-form__step--' + step).show()
      requestAnimationFrame(function() {
        $('.inscription-form__step--' + step).attr('aria-hidden', 'false')
        steps.current = step
      })
    })
  },

  nextStep() {
    let steps = this, step = steps.current, hasStep = false
    while (!hasStep) {
      step += 1
      if ($('.inscription-form__step--' + step).length) {
        hasStep = true
      }
    }
    steps.switchTo(step)
  },

  initializeStripe(client_secret) {
    const stripe = Stripe(culturemontreal_l10n.stripe_pk)
    const options = {
      clientSecret: client_secret,
      appearance: {
        theme: 'flat',
        variables: {
          colorDanger: '#ef0000',
          fontFamily: '"PxGroteskLight", system-ui, sans-serif',
        },
      },
      locale: 'fr',
    };

    self.stripe_form = $('#stripe-payment-form')

    const elements = stripe.elements(options),
    paymentElement = elements.create('payment')
    paymentElement.mount('#payment-element')
    const form = self.stripe_form.get(0)
    form.addEventListener('submit', async (event) => {
      event.preventDefault();

      const {error} = await stripe.confirmPayment({
        elements,
        confirmParams: {
          return_url: culturemontreal_l10n.inscription_url + '?st=Completed',
        },
      });

      if (error) {
        const messageContainer = document.querySelector('#stripe-error-message');
        messageContainer.textContent = error.message;
      }
    });
  },

  setFormID(form_id) {
    $('.inscription-form__part-1, .inscription-form__part-2, .inscription-form__part-3, .inscription-form__part-4').find('input[name="form_id"]').val(form_id)
  },
}
